export type ConnectionIssueKind = "connection" | null;

export function resolveConnectionIssueKind(opts: {
  isOnline: boolean;
  isAuthenticated: boolean;
  isReconnecting: boolean;
  hasConnectionError: boolean;
  /** A live hub connection exists. Absence of an error is not the same thing. */
  hasLiveConnection?: boolean;
  /** A hub connection has been established at least once this session. */
  hasEverConnected?: boolean;
}): ConnectionIssueKind {
  if (!opts.isOnline) return null;
  if (!opts.isAuthenticated) return null;

  const lostConnection = opts.hasEverConnected === true && opts.hasLiveConnection === false;

  if (opts.isReconnecting || opts.hasConnectionError || lostConnection) return "connection";
  return null;
}

export function hasRecovered(opts: {
  isOnline: boolean;
  isAuthenticated: boolean;
  hasLiveConnection: boolean;
}): boolean {
  if (!opts.isOnline) return false;
  return !opts.isAuthenticated || opts.hasLiveConnection;
}
